import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_LINK_OPTIONS } from '@Pages/RetroSynthesis/LinkOption/constants';

const getRsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);

export const getLinkOptionsData = (state) => getRsState(state).get(REDUCER_KEY_LINK_OPTIONS);
